module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_8017.986a96a8.png";